const base = process.env.REACT_APP_BACKEND_URL;
let csrfToken = '';
let refreshPromise = null;
export const setStaffCsrf = value => { csrfToken = value || ''; };

const messageFrom = detail => {
  if (Array.isArray(detail)) return detail.map(item => item.msg || 'Invalid field').join(' ');
  return typeof detail === 'string' ? detail : 'The request could not be completed.';
};

async function refreshSession() {
  const response = await fetch(`${base}/api/auth/refresh`, {method: 'POST', credentials: 'include', signal: AbortSignal.timeout(15000)});
  if (!response.ok) return false;
  const data = await response.json(); setStaffCsrf(data.csrfToken);
  return true;
}

export async function staffApi(path, {method = 'GET', body, retry = true} = {}) {
  let response;
  try {
    response = await fetch(`${base}/api${path}`, {method, credentials: 'include', cache: 'no-store', signal: AbortSignal.timeout(20000),
      headers: {'Content-Type': 'application/json', ...(csrfToken ? {'X-CSRF-Token': csrfToken} : {})},
      ...(body !== undefined ? {body: JSON.stringify(body)} : {})});
  } catch { throw new Error('We couldn’t connect. Your unsaved work is still here. Please try again.'); }
  if (response.status === 401 && retry && path !== '/auth/login') {
    if (!refreshPromise) refreshPromise = refreshSession().catch(() => false).finally(() => { refreshPromise = null; });
    if (await refreshPromise) return staffApi(path, {method, body, retry: false});
  }
  let data;
  try {data = await response.json();}
  catch {throw new Error('The server could not complete this request. Your unsaved work is still here. Please try again.');}
  if (!response.ok) { const error = new Error(messageFrom(data.detail)); error.status = response.status; throw error; }
  return data;
}